<script setup>
import Checkbox from '@legacy/components/common/form/checkbox/Checkbox.vue';
import GenericModal from '@legacy/components/common/modal/GenericModal.vue';
import KgrButton from '@legacy/components/common/form/button/KgrButton.vue'
import { ref } from 'vue';

const { showDialog } = defineProps({
    showDialog: {
        type: Boolean,
        required: true,
    },
});

const emit = defineEmits(['cancel', 'confirm']);
const doPrecheck = ref(false);

const handleConfirm = () => {
    emit('confirm', {
        doPrecheck: doPrecheck.value,
    });
};

const handleCancel = () => {
    emit('cancel');
};
</script>

<template>
    <generic-modal
        v-if="showDialog"
        :value="showDialog"
        :headline="$t('confirmInformal')"
        @post-input="handleCancel"
    >
        <div class="kgr-readingBlock">
            {{ $t('Willst du wirklich einen Rechnungslauf durchführen?') }}
        </div>
        <div class="kgr-readingBlock mt1">
            {{ $t('Du kannst vor dem Rechnungslauf für alle SEPA-Lastschriften die IBAN und BIC überprüfen lassen.') }}<br />
            {{ $t('Ungültige IBANs und BICs werden dir in einer Liste angezeigt. Der Rechnungslauf wird dann nicht gestartet.') }}
        </div>
        <div class="mt1">
            <checkbox
                :checked="doPrecheck"
                :label="$t('SEPA-Lastschriften-Check ausführen')"
                click-area-minimized
                @change="value => (doPrecheck = value)"
            />
        </div>
        <template #footer>
            <kgr-button
                type="grey"
                :value="$t('Abbrechen')"
                @click="handleCancel"
            />
            <kgr-button
                :value="$t('Ok')"
                @click="handleConfirm"
            />
        </template>
    </generic-modal>
</template>

<style scoped lang="scss">
</style>
